const datafacultad = [
    {
        "id_facultad": 1,
        "facultad": "Economía y Negocios"
    },
    {
        "id_facultad": 2,
        "facultad": "Derecho"
    },
    {
        "id_facultad": 3,
        "facultad": "Ciencias Actuariales"
    },
    {
        "id_facultad": 4,
        "facultad": "Bioética"
    },
    {
        "id_facultad": 5,
        "facultad": "Educación"
    },
    {
        "id_facultad": 6,
        "facultad": "Ciencias de la Salud "
    },
    {
        "id_facultad": 7,
        "facultad": "Comunicación y Mercadotecnia"
    },
    {
        "id_facultad": 8,
        "facultad": "Humanidades"
    },
    {
        "id_facultad": 9,
        "facultad": "Ingeniería"
    },
    {
        "id_facultad": 10,
        "facultad": "Responsabilidad Social"
    },
    {
        "id_facultad": 11,
        "facultad": "Turismo y Gastronomía"
    },
    {
        "id_facultad": 12,
        "facultad": "Arquitectura y Diseño "
    },
    {
        "id_facultad": 13,
        "facultad": "Estudios Globales "
    },
  /*  {
        "id_facultad": 14,
        "facultad": "Arquitectura "
    },*/
    {
        "id_facultad": 15,
        "facultad": "Ciencias del Deporte"
    },
    {
        "id_facultad": 16,
        "facultad": "Psicología"
    },
   /* {
        "id_facultad": 17,
        "facultad": "Liderazgo "
    },*/
    {
        "id_facultad": 18,
        "facultad": "Diseño"
    },
    {
        "id_facultad": 19,
        "facultad": "Negocios"
    },
    {
        "id_facultad": 20,
        "facultad": "Contabilidad y Finanzas",
    },
    {
        "id_facultad": 21,
        "facultad": "Ciencia de Datos",
    }
]

export default datafacultad;